import type { FilterOptionValue } from '@latitude/filter-toolbar';

// Seeds initial state directly from raw ids, unlike `createSelectFilter`'s
// own `initialValue`, which matches against `options` — options that may
// still be loading (e.g. from a GraphQL query) when this needs to run.
export const toFilterOptionValue = (
  value?: string | string[] | null,
): FilterOptionValue | undefined => {
  const ids = Array.isArray(value) ? value : value ? [value] : [];
  return ids.length
    ? Object.fromEntries(ids.map((id) => [id, true]))
    : undefined;
};
